<template>
  <div id="qvv_sterblichkeit">
    <h1>Gestorbene pro Woche in ausgewählten Ländern</h1>
    <p>
      Anzahl gestorbener Personen pro Woche im Jahr 2020 im Vergleich zum
      langjährigen Durchschnitt.
    </p>
    <div class="controls" v-if="false">
      <button
        v-for="k in POSSIBLE_VALUES_ORDER"
        :key="k"
        @click="value = k"
        v-html="POSSIBLE_VALUES[k].title"
        :class="{ active: value == k }"
        :disabled="value == k ? 'disabled' : null"
      ></button>
      <button @click="toggle_scatter_x()" v-if="false">x axis toggle</button>
    </div>
    <div class="graph">
      <div
        v-for="x in erste_n_bezirke"
        :key="x.country"
        :class="`bezirk ${x.country}`"
      >
        <h4 v-if="x.country == 'Österreich'">
          <span :style="{ borderBottom: `3px solid #8e8e8e` }">
            Österreich
          </span>
        </h4>
        <h4 v-else>
          <span
            :style="{
              borderBottom: `3px solid ${
                x.country == 'Österreich' ? '#8e8e8e' : '#CA5775'
              }`
            }"
          >
            {{ x.country }}
          </span>
        </h4>
        <div class="scatter_wrapper">
          <ScatterplotMortalitaet
            :bezirk="bezirkeWerte[x.country]"
            :color="x.country == 'Österreich' ? '#8e8e8e' : '#CA5775'"
            :alle="[]"
            :value="value"
            :formatter="POSSIBLE_VALUES[value].formatter"
            :other_values="POSSIBLE_VALUES_ORDER.filter(d => d != value)"
            :other_values_instructions="POSSIBLE_VALUES"
            :xaxis="scatter_x"
            :times_avg="x.country.indexOf(',') >= 0 && false ? 5 : 3"
            :styles="{
              height: mobile
                ? '200px'
                : x.country.indexOf(',') && false
                ? '350px'
                : '200px',
              width: `${Math.min(Math.floor(componentWidth) / 2, 200)}px`
            }"
            v-if="componentWidth"
          >
          </ScatterplotMortalitaet>
        </div>
      </div>
    </div>
    <p class="detail"></p>
    <footer>
      <p class="source">
        Quelle: Statistik Austria, DESTATIS, BFS, SCB, EPISTAT, ISTAT, Instituto
        de Salud Carlos III, CDC,
        <a
          href="https://github.com/Financial-Times/coronavirus-excess-mortality-data"
          target="_blank"
          >Financial Times
        </a>
      </p>
    </footer>
  </div>
</template>

<script>
import ScatterplotMortalitaet from "./components/ScatterplotMortalitaet.vue";
import Vue from "vue";
import * as fetch from "d3-fetch";
import ComponentSizeMixin from "./components/ComponentSizeMixin";

export default {
  name: "Sterblichkeit",
  components: {
    ScatterplotMortalitaet
  },
  mixins: [ComponentSizeMixin],
  data: () => {
    const POSSIBLE_VALUES = {
      "2020": {
        parser: x => parseInt(x),
        formatter: x => (isNaN(x) ? "" : Vue.prototype.$fmt(".2r")(x)),
        title: "2020"
      },
      Minimalwert: {
        parser: x => parseFloat(x),
        formatter: x => (isNaN(x) ? "" : Vue.prototype.$fmt(".2r")(x)),
        title: "Minimalwert"
      },
      Maximalwert: {
        parser: x => parseFloat(x),
        formatter: x => (isNaN(x) ? "" : Vue.prototype.$fmt(".2r")(x)),
        title: "Maximalwert"
      }
    };
    return {
      mobile: false,
      cutoff: true,
      value: "2020",
      POSSIBLE_VALUES: POSSIBLE_VALUES,
      POSSIBLE_VALUES_ORDER: ["2020", "Minimalwert", "Maximalwert"],
      bezirksdaten_timeline: [],
      cutoff_length: 12,
      scatter_x: "day"
    };
  },
  mounted() {
    window.addEventListener("resize", this.update_mobile);
    this.update_mobile();
    this.$nextTick(this.fetch_data);
  },
  methods: {
    update_mobile() {
      this.mobile = window.innerWidth < 700;
    },
    toggle_scatter_x() {
      this.scatter_x = this.scatter_x == "day" ? "bf" : "day";
    },
    fetch_data() {
      fetch.csv(`${process.env.BASE_URL}mortality_country.csv`).then((data) => { //eslint-disable-line
        data.forEach(x => {
          x.week = parseInt(x.week);
          Object.keys(this.POSSIBLE_VALUES).forEach(k => {
            x[k] = this.POSSIBLE_VALUES[k].parser(x[k]);
          });
        });
        this.bezirksdaten_timeline = data;
      });
    }
  },
  computed: {
    max() {
      var max = 0;
      this.bezirksdaten_timeline.map(d => {
        max = Math.max(max, d[this.value]);
      });
      return max;
    },
    bezirke() {
      return [...new Set(this.bezirksdaten_timeline.map(d => d.country))];
    },
    bezcodename() {
      return this.bezirke.map(bezcode => ({
        bezcode: bezcode,
        name: this.bezirkeWerte[bezcode][0].country
      }));
    },
    datumswerte() {
      return [...new Set(this.bezirksdaten_timeline.map(d => d.week))];
    },
    stand() {
      return ""; //this.bezirksdaten_timeline[0].stand;
    },
    bezirkeWerte() {
      return Object.fromEntries(
        this.bezirke.map(bezirk => {
          const tmp = this.bezirksdaten_timeline.filter(
            d => d.country == bezirk
          );
          tmp.sort((a, b) => a.week - b.week);
          return [bezirk, tmp];
        })
      );
    },
    erste_n_bezirke() {
      const tmp = Object.entries(this.bezirkeWerte).map(d => d[1].slice(-1)[0]);
      tmp.sort((a, b) => b[this.value] - a[this.value]);
      return tmp.slice(0, this.cutoff ? this.cutoff_length : tmp.length);
    }
  }
};
</script>

<style scoped>
#qvv_sterblichkeit {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 21px;
}

h1 {
  font-family: Roboto, sans-serif;
  font-size: 22px;
  line-height: 29px;
  margin-bottom: 12px;
  margin-top: 0;
}

div.graph {
  margin-top: 24px;
  margin-bottom: 24px;
}

footer {
  background: none;
  padding: 0;
  margin: 0;
  display: flex;
}

p.detail {
  font-size: 14px;
  line-height: 21px;
  margin: 0;
}

footer p.source {
  color: #888;
  text-align: right;
  font-size: 11px;
  line-height: 17px;
  margin: 0;
  flex: 1;
  padding-top: 1px;
  -webkit-text-size-adjust: 100%;
}
p.source strong {
  font-weight: normal;
  text-transform: uppercase;
}

p {
  line-height: 21px;
  margin: 0px;
}

@media (max-width: 700px) {
  table {
    font-size: 12px;
    line-height: 16px;
  }
  tr th,
  tr td {
    padding: 4px 5px 0px;
  }

  p.detail {
    font-size: 11px;
    line-height: 14px;
  }
}

.graph {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.bezirk {
  display: flex;
  flex-direction: column;
  width: 200px;
  padding: 5px;
  justify-content: flex-end;
}

@media (max-width: 450px) {
  .bezirk {
    width: 50%;
    padding: 0;
  }
}

.search {
  position: relative;
}

.search >>> input {
  width: 100%;
  border: 1px solid grey;
}

.search .results {
  width: 100%;
  max-width: 450px;
  position: absolute;
  border: 1px solid #333;
  border-bottom: none;
  box-sizing: border-box;
  color: black;
  z-index: 100;
}

.search .results .r {
  border-bottom: 1px solid black;
  padding: 5px 10px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.8);
}

.search .results .r.highlight {
  background: #a0968b;
}

h4,
.search >>> input {
  margin: 0;
  font-size: 14px;
  padding-bottom: 2px;
  font-weight: normal;
}

h4 {
  line-height: 24px;
}

.search >>> input {
  font-family: Roboto, sans-serif;
  line-height: 19px;
  margin-top: -1px;
}
.search >>> input::placeholder {
  font-family: Roboto, sans-serif;
}

.bezirk.cutoff {
  display: flex;
  flex-direction: column;
}

.bezirk.cutoff .placeholder {
  display: flex;
  align-content: center;
  flex-direction: column;
  justify-content: center;
  flex-grow: 2;
  vertical-align: middle;
  text-align: center;
}

button {
  border: none;
  font-size: 16px;
  padding: 0.28em 20px 0.25em;
  margin-left: 1em;
  cursor: pointer;
  background: #ca5775;
  color: white;
  border-radius: 50px;
  vertical-align: top;
}
button:hover {
  background: #bb8b98;
}
button.active {
  cursor: inherit;
  font-weight: bold;
  background: #bb8b98;
}
button.active:hover {
  background: #bb8b98;
}

.bezirk.cutoff .placeholder label {
  background: #ca5775;
  max-width: 75%;
  padding: 0.28em 20px 0.2em;
  color: white;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  border-radius: 50px;
}
.bezirk.cutoff .placeholder label:hover {
  background: #bb8b98;
}

button:first-child {
  margin-left: 0;
}

.controls {
  margin-top: 0.75em;
  text-align: center;
}

span.mark {
  font-size: 8px;
  line-height: 8px;
  font-weight: bold;
  display: inline-block;
  background: #8e8e8e;
  color: white;
  padding: 2px 3px;
  border-radius: 100px;
  vertical-align: middle;
  text-align: center;
  width: 11px;
  height: 11px;
  box-sizing: border-box;
}
</style>
